var PromoBar = class extends HTMLElement {
  constructor() {
    super();
    this.cartData = null;
    this.prices = this.querySelectorAll(".item__price");
    this.labels = this.querySelectorAll(".item__label");
    this.markers = this.querySelectorAll(".item__marker");
    this.bar = this.querySelector(".bar");
    this.barTrack = this.querySelector(".bar__track");
    this.toReachNextGoal = this.querySelector('[role="to-reach-next-goal"]');
    this.nextGoalLabel = this.querySelector('[role="next-goal-label"]');
    this.currency = this.dataset.currency;
  }
  connectedCallback() {
    console.log(this.currency);
    fetch(`${Shopify.routes.root}cart.js`)
      .then((res) => res.json())
      .then((res) => {
        this.cartData = res;
        this.calculateBarPosition();
      });
  }

  calculateBarPosition() {
    let prices = [];
    const cartPrice = this.cartData.total_price / 100;
    this.prices.forEach((price) => {
      const priceNumber = +price.innerHTML.replace(this.currency, "");
      prices.push(priceNumber);
    });

    const percent = 100 / prices.length;
    const halfPercent = percent / 2;
    let lastPercent = 0;

    for (let i = 0; i < prices.length; i++) {
      const price = prices[i];
      if (cartPrice >= price) {
        lastPercent += i == 0 ? halfPercent : percent;
        if (i >= prices.length - 1) {
          this.barTrack.style.width = `100%`;
          this.toReachNextGoal.innerHTML = `${(0).toFixed(2)}${this.currency}`;
        }
      } else {
        if (i == 0) {
          this.barTrack.style.width = `${(cartPrice * halfPercent) / price}%`;
        } else {
          const priceRange = price - prices[i - 1];
          const totalToCompare = cartPrice - prices[i - 1];
          const rangePercent = (totalToCompare * percent) / priceRange;
          this.barTrack.style.width = `${rangePercent + lastPercent}%`;
        }
        this.toReachNextGoal.innerHTML = `${(price - cartPrice).toFixed(2)}${
          this.currency
        }`;
        this.nextGoalLabel.innerHTML = this.labels[i].innerHTML;
        break;
      }
    }
  }
};
if (!window.customElements.get("promo-bar")) {
  window.customElements.define("promo-bar", PromoBar);
}
